import PropTypes from 'prop-types'
import ModalView from 'components/CommonUI/ModalView'
import Icon from 'components/Icon'
import Type from 'components/Type'
import ModalActions from 'components/CommonUI/ModalActions'
import TextButton from 'components/TextButton'
import CircleFrame from 'components/CommonUI/CircleFrame'
import Img from 'components/Img'
import Spinner from 'components/Spinner'
import Box from '@mui/material/Box'
import { useTypeLoad } from 'utils/hooks'
import { useAction } from 'utils/actions'

const StandardModal = ({
  icon,
  frameIcon,
  customIcon,
  src,
  title,
  secondaryTitle,
  subtitle,
  body,
  button,
  centerAction,
  actionOne,
  actionOneType,
  actionTwo,
  actionTwoType,
  closeModalAction,
  modalProps,
  iconProps,
  iconError,
}) => {
  const { closeModal, closeDrawer } = useAction()

  const actionOneLoading = useTypeLoad(actionOneType, data => {
    if (data.error) closeModal()
  })

  const actionTwoLoading = useTypeLoad(actionTwoType, data => {
    if (data.error) closeModal()
  })

  const handleActionOne = () => {
    if (closeModalAction === 'one') {
      closeModal()
      closeDrawer()
    }
  }

  const handleActionTwo = () => {
    if (closeModalAction === 'two') {
      closeModal()
      closeDrawer()
    }
  }

  return (
    <ModalView sizeX="md" {...modalProps}>
      <Box display="grid" gap={2} p={3}>
        {(icon || customIcon || src) && (
          <Box display="grid" justifyContent="center">
            {icon && !frameIcon && <Icon icon={icon} {...iconProps} />}
            {icon && frameIcon && (
              <CircleFrame
                icon={icon}
                iconProps={iconProps}
                error={iconError}
              />
            )}
            {customIcon}
            {src && (
              <CircleFrame 
                mb={2}
              >
                <Box
                  height="100%"
                  width="100%"
                  maxWidth="80px"
                  maxHeight="80px"
                >
                  <Img
                    src={src}
                    // alt={}
                  />
                </Box>
              </CircleFrame>
            )}
          </Box>
        )}
        <Box display="grid" gap={1.5} textAlign="center">
          <Box display="grid" gap={1}>
            <Type variant="sectionLabel">{title}</Type>
            {secondaryTitle && (
              <Type variant="subtitleLarge">{secondaryTitle}</Type>
            )}
          </Box>
          {(subtitle || body) && (
            <Box display="grid" gap={1}>
              {subtitle && <Type variant="p">{subtitle}</Type>}
              {body && (
                <Type variant="dataSmall" color="neutralCool_700">
                  {body}
                </Type>
              )}
            </Box>
          )}
        </Box>
        {button && (
          <Box display="grid" justifyContent="center" mt={1}>
            {button}
          </Box>
        )}
      </Box>
      {(actionOne || actionTwo) && (
        <ModalActions
          centerAction={centerAction}
        >
          {actionOne && (
            <TextButton onMouseUp={handleActionOne}>{actionOne}</TextButton>
          )}
          {actionTwo && (
            <TextButton color="neutralCool_700" onMouseUp={handleActionTwo}>
              {actionTwo}
            </TextButton>
          )}
        </ModalActions>
      )}
      {(actionOneLoading.isLoading || actionTwoLoading.isLoading) && (
        <Spinner position="fixed" />
      )}
    </ModalView>
  )
}

StandardModal.propTypes = {
  icon: PropTypes.string,
  customIcon: PropTypes.any,
  src: PropTypes.string,
  title: PropTypes.string,
  secondaryTitle: PropTypes.string,
  subtitle: PropTypes.string,
  body: PropTypes.any,
  button: PropTypes.any,
  actionOne: PropTypes.any,
  actionOneType: PropTypes.string,
  actionTwo: PropTypes.any,
  actionTwoType: PropTypes.string,
  closeModalAction: PropTypes.oneOf(['one', 'two', 'none']),
  modalProps: PropTypes.object,
  iconProps: PropTypes.object,
  frameIcon: PropTypes.bool,
  centerAction: PropTypes.bool,
}

StandardModal.defaultProps = {
  actionOneType: '',
  actionTwoType: '',
  modalProps: {},
  iconProps: {},
}

export default StandardModal
